module.exports = __webpack_public_path__ + "img/myprize.787bf5c3.png";